// src/components/layout/Navbar/CompaniesDropdown.js
import { useTranslation } from 'react-i18next'
import { LuBuilding2 } from 'react-icons/lu'
import { useCompany } from 'contexts/CompanyContext'

// Selector de empresa para administradores: permite ver los datos de cualquier
// empresa (contactos, llamadas, dashboard) o de todas a la vez.
// La lista y la preselección las resuelve CompanyContext, no este componente.
export default function CompaniesDropdown() {
  const { t } = useTranslation()
  const {
    selectedCompanyId, setSelectedCompany, canSwitchCompany, companies,
  } = useCompany()

  if (!canSwitchCompany) return null

  return (
    <label className="flex h-9 items-center gap-2 rounded-lg border border-gray-200 bg-white pl-2.5 pr-1 text-sm text-gray-700 focus-within:border-brand focus-within:ring-4 focus-within:ring-brand-soft">
      <LuBuilding2 size={16} className="flex-none text-gray-500" aria-hidden="true" />
      <span className="sr-only">{t('layout:navbar.company')}</span>
      <select
        value={selectedCompanyId ?? ''}
        onChange={(e) => {
          const company = companies.find(c => String(c.id) === e.target.value)
          setSelectedCompany(company ? { id: company.id, name: company.name } : null)
        }}
        className="h-full max-w-[200px] cursor-pointer truncate bg-transparent pr-1 font-medium text-gray-900 focus:outline-none"
      >
        <option value="">{t('companies_dropdown.all')}</option>
        {companies.map(company => (
          <option key={company.id} value={String(company.id)}>
            {company.name}
          </option>
        ))}
      </select>
    </label>
  )
}
